/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * User organization request for biz admin review
 */
import { ValidateUtils } from 'app/shared/utils';

export class OrganizationRequest { 
    /**
     * Unique identifier for the organization request
     */
    readonly requestId: number;
    /**
     * Miradi object resource identifier
     */
    userIdentifier: string;
    /**
     * User\'s username
     */
    readonly username: string;
    /**
     * First name
     */
    readonly firstName?: string;
    /**
     * Last name
     */
    readonly lastName?: string;
    /**
     * User\'s email address
     */
    readonly email: string;
    /**
     * User-reported organization name
     */
    readonly reportedOrganizationName: string;
    /**
     * User-reported organization website URL
     */
    readonly reportedOrganizationWebsiteUrl?: string | null;
    /**
     * User\'s email domain at time of request
     */
    readonly emailDomain?: string | null;
    /**
     * When the request was created
     */
    readonly createdDate?: string | null;
    /**
     * When account setup was completed
     */
    readonly accountSetupCompletedDatetime?: string | null;
    /**
     * Resolution status (Pending, Assigned to Organization, Dismissed)
     */
    readonly resolutionStatus?: string | null;
    /**
     * Notes from biz admin about the resolution
     */
    readonly resolutionNotes?: string | null;
    /**
     * When the request was resolved
     */
    readonly resolvedDatetime?: string | null;
    /**
     * Name of the biz admin who resolved the request
     */
    readonly resolvedByName?: string | null;
    /**
     * Name of the organization user was assigned to (if resolved as assigned)
     */
    readonly assignedOrganizationName?: string | null;

    constructor(item?: Partial<OrganizationRequest>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            requestId: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.requestId : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            userIdentifier: {
                type: 'uuid',
                minLength: 36,
                maxLength: 36,
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.userIdentifier : itemOrValue;

                    if (itemOrValue?.userIdentifier != null) {
                        if (itemOrValue.userIdentifier === '') {
                            itemOrValue.userIdentifier = undefined;
                        } else if (['int32', 'int64'].indexOf('uuid') >= 0) {
                            itemOrValue.userIdentifier = parseInt(itemOrValue.userIdentifier.toString(), 10);
                        } else if (['float'].indexOf('uuid') >= 0) {
                            itemOrValue.userIdentifier = parseFloat(itemOrValue.userIdentifier.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'uuid');
                    if (['uuid'].indexOf('uuid') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, 36, 36);
                    }

                    return result;
                }
            },
            username: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.username : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            firstName: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.firstName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            lastName: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.lastName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            email: {
                type: 'email',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.email : itemOrValue;

                    if (itemOrValue?.email != null) {
                        if (itemOrValue.email === '') {
                            itemOrValue.email = undefined;
                        } else if (['int32', 'int64'].indexOf('email') >= 0) {
                            itemOrValue.email = parseInt(itemOrValue.email.toString(), 10);
                        } else if (['float'].indexOf('email') >= 0) {
                            itemOrValue.email = parseFloat(itemOrValue.email.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'email');
                    if (['uuid'].indexOf('email') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            reportedOrganizationName: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.reportedOrganizationName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            reportedOrganizationWebsiteUrl: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.reportedOrganizationWebsiteUrl : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            emailDomain: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.emailDomain : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            createdDate: {
                type: 'date-time',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.createdDate : itemOrValue;

                    if (itemOrValue?.createdDate != null) {
                        if (itemOrValue.createdDate === '') {
                            itemOrValue.createdDate = undefined;
                        } else if (['int32', 'int64'].indexOf('date-time') >= 0) {
                            itemOrValue.createdDate = parseInt(itemOrValue.createdDate.toString(), 10);
                        } else if (['float'].indexOf('date-time') >= 0) {
                            itemOrValue.createdDate = parseFloat(itemOrValue.createdDate.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date-time');
                    if (['uuid'].indexOf('date-time') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            accountSetupCompletedDatetime: {
                type: 'date-time',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.accountSetupCompletedDatetime : itemOrValue;

                    if (itemOrValue?.accountSetupCompletedDatetime != null) {
                        if (itemOrValue.accountSetupCompletedDatetime === '') {
                            itemOrValue.accountSetupCompletedDatetime = undefined;
                        } else if (['int32', 'int64'].indexOf('date-time') >= 0) {
                            itemOrValue.accountSetupCompletedDatetime = parseInt(itemOrValue.accountSetupCompletedDatetime.toString(), 10);
                        } else if (['float'].indexOf('date-time') >= 0) {
                            itemOrValue.accountSetupCompletedDatetime = parseFloat(itemOrValue.accountSetupCompletedDatetime.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date-time');
                    if (['uuid'].indexOf('date-time') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            resolutionStatus: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.resolutionStatus : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            resolutionNotes: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.resolutionNotes : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            resolvedDatetime: {
                type: 'date-time',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.resolvedDatetime : itemOrValue;

                    if (itemOrValue?.resolvedDatetime != null) {
                        if (itemOrValue.resolvedDatetime === '') {
                            itemOrValue.resolvedDatetime = undefined;
                        } else if (['int32', 'int64'].indexOf('date-time') >= 0) {
                            itemOrValue.resolvedDatetime = parseInt(itemOrValue.resolvedDatetime.toString(), 10);
                        } else if (['float'].indexOf('date-time') >= 0) {
                            itemOrValue.resolvedDatetime = parseFloat(itemOrValue.resolvedDatetime.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date-time');
                    if (['uuid'].indexOf('date-time') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            resolvedByName: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.resolvedByName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            assignedOrganizationName: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.assignedOrganizationName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: OrganizationRequest.isValid,
        };
    }

    static isValid(obj: OrganizationRequest): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = OrganizationRequest.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.requestId.isValid(item);
            result = result && validationObject.userIdentifier.isValid(item);
            result = result && validationObject.username.isValid(item);
            result = result && validationObject.firstName.isValid(item);
            result = result && validationObject.lastName.isValid(item);
            result = result && validationObject.email.isValid(item);
            result = result && validationObject.reportedOrganizationName.isValid(item);
            result = result && validationObject.reportedOrganizationWebsiteUrl.isValid(item);
            result = result && validationObject.emailDomain.isValid(item);
            result = result && validationObject.createdDate.isValid(item);
            result = result && validationObject.accountSetupCompletedDatetime.isValid(item);
            result = result && validationObject.resolutionStatus.isValid(item);
            result = result && validationObject.resolutionNotes.isValid(item);
            result = result && validationObject.resolvedDatetime.isValid(item);
            result = result && validationObject.resolvedByName.isValid(item);
            result = result && validationObject.assignedOrganizationName.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

